import type { Role } from "@/layouts/types/sidebar.types";

/*
 * Which roles may open each role-restricted dashboard route. The sidebar
 * builds its menu from the same lists, so a page is reachable by URL exactly
 * when it is offered in the menu. This only decides what the UI renders -
 * the backend still authorizes every request on its own.
 */
export type AllowedRoles = readonly Role[] | "ANY";

export const ROUTE_ROLES = {
  users: ["MADAR_ADMIN"],
  settings: ["MADAR_ADMIN"],
  files: ["MADAR_ADMIN", "CLIENT"],
  comments: ["MADAR_ADMIN", "PROVIDER_ADMIN", "DATA_ANALYST", "CLIENT"],
  myProjects: ["CLIENT"],
} as const satisfies Record<string, Role[]>;

export const normRoles = (roles?: unknown): Role[] => {
  if (!Array.isArray(roles)) return [];

  return roles
    .map((role) =>
      String(role || "")
        .toUpperCase()
        .replace(/\s+/g, "_"),
    )
    .filter(Boolean) as Role[];
};

export const hasAnyRole = (
  userRoles: readonly Role[],
  allowed: readonly Role[] | "ANY",
) => {
  return allowed === "ANY"
    ? true
    : allowed.some((role) => userRoles.includes(role));
};

export const getStoredUserRoles = (): Role[] => {
  try {
    const raw = localStorage.getItem("userData");
    if (!raw) return [];

    // Same field the sidebar reads, so menu and routes always agree.
    return normRoles(JSON.parse(raw)?.roles);
  } catch {
    return [];
  }
};
